<template>
  <CRow>
    <CCol lg="12">
      <CCard>
        <CCardHeader>
          <strong>Quản lý hợp đồng</strong>
          <div class="card-header-actions">

            <CSpinner
              v-if="isUploading"
              color="info"
              class="mr-5 mt-0"
              style="width:1.2rem;height:1.2rem;"
            />

            <label
              style="border: 1px solid #ced4da;border-radius: 0.375rem;padding: 0.375rem 0.75rem;"
              class="mr-1"
              for="fileInput"
            >{{ fileName }}
            </label>
            <input type="file"
                   id="fileInput"
                   style="display: none;"
                   @change="onFileChange">

            <CButton shape="pill" color="info"
                     style="width: 120px;"
                     class="mr-lg-5"
                     @click="handleSubmit"
                     :disabled="isUploading"
            >
              <CIcon name="cil-cloud-upload"/>
              {{ isUploading ? "Đang tải..." : "Tải lên" }}
            </CButton>

            <CButton type="button" shape="pill" color="info" @click="createNew">
              <CIcon name="cil-plus"/>
              Thêm mới</CButton>
          </div>
        </CCardHeader>
        <CCardBody class="pt-0">
          <CDataTable
            :items="contracts"
            :fields="fields"
            :tableFilter="{label :'Bộ lọc: ', placeholder:'Nội dung' }"
            :itemsPerPageSelect="{label:' ', values: ['10', '100', '200']}"
            :itemsPerPage="100"
            hover
            sorter
            column-filter
            clickable-rows
            pagination
            @row-clicked="editRecord"
          >
            <template #no-items-view>
              <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                Danh sách trống!
              </div>
            </template>


          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
export default {
  data() {
    return {
      // Define the table fields
      fields: [
        { key: 'id', label: 'Stt', _style:'width:3rem;'},
        { key: 'customer', label: 'Đối tác'},
        { key: 'contract', label: 'Hợp đồng', _classes: 'font-weight-bold' },
        { key: 'day', label: 'Ngày', _style:'width:3rem;'},
        { key: 'month', label: 'Tháng', _style:'width:3rem;' },
        { key: 'year', label: 'Năm', _style:'width:5rem;' },
        { key: 'content', label: 'Nội dung thực hiện' },
        { key: 'copies', label: 'Số bản' },
        { key: 'note', label: 'Ghi chú' },
      ],
      // Example data
      contracts: [],
      fileName: 'Nhập từ tệp', // for purge BOM file upload
      selectedFile: null,
      isUploading: false,
    };
  },
  created() {
    this.getAll()
  },
  methods: {
    getAll() {
      this.$request('/api/device/contract').then(res => {
        // console.log(res.data)
        this.contracts = res.data.contracts
      })
    },
    editRecord(item, index) {
      // console.log('Edit record:', item);
      this.$router.push({
        path: `/device/ctredit`,
        query: {
          id: item.id,
        },
      })
    },
    createNew() {
      this.$router.push({
        path: '/device/ctredit',
      })
    },
    onFileChange(event) {
      this.selectedFile = event.target.files[0];
      if (this.selectedFile) {
        this.fileName = this.selectedFile.name;
        // console.log('selected file name:', this.fileName)
      } else {
        // console.log('no file selected');
        this.fileName = 'Nhập từ tệp'
      }
    },
    handleSubmit() {
      if (!this.selectedFile) {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên",
          text: "Vui lòng chọn tệp trước"
        });
        return;
      }

      // Create FormData instance to hold the file
      this.isUploading = true;
      const formData = new FormData();
      formData.append("file", this.selectedFile);
      // Send file using Axios
      this.$request.post("/api/device/contract/import", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          if (res.data.status === 'success') {
            // console.log(res.data.status)
            this.$swal.fire({
              icon: "success",
              title: "Tải lên tệp",
              text: "Tệp: " + this.fileName + " đã tải lên thành công!",
            });
            this.getAll()
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Tải lên tệp",
              html: "Tệp: " + this.fileName + " tải lên lỗi: " + res.data.status,
            });
          }
          this.isUploading = false;
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Tải lên tệp",
            html: "Tệp: " + this.fileName + " tải lên lỗi: " + error,
          });
          this.isUploading = false;
        });
    },
  }
};
</script>
